import { StaticImage } from "gatsby-plugin-image"

import EditQuestionnaire from "../edit-questionnaire"
import UserNote from "../user-note"

import Card from "./card"
import ChoosePlan from "./choose-plan"

const Steps = () => (
  <>
    <Card status="completed">
      <EditQuestionnaire />

      <UserNote />
    </Card>

    <ChoosePlan />

    <Card>
      <div
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 3,
          fontWeight: 600,
          lineHeight: "26px",
        }}
      >
        <span>
          Lade 3 Fotos zur Analyse durch Deinen{" "}
          <span sx={{ whiteSpace: "nowrap" }}>Arzt/Deine Ärztin hoch</span>
        </span>
        <StaticImage
          src="./images/photos_3x.webp"
          alt=""
          sx={{ width: 71, flexShrink: 0 }}
        />
      </div>
    </Card>
    <Card>
      <div
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 3,
          fontWeight: 600,
          lineHeight: "26px",
        }}
      >
        <span>
          <span sx={{ whiteSpace: "nowrap" }}>Erhalte Deine Diagnose</span>{" "}
          <span sx={{ whiteSpace: "nowrap" }}>in weniger als 72h</span>
        </span>
        <StaticImage
          src="./images/diagnosis_2x.png"
          alt=""
          height={32}
          sx={{ flexShrink: 0 }}
        />
      </div>
    </Card>
    <Card showLine={false}>
      <div
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: 3,
          fontWeight: 600,
          lineHeight: "26px",
        }}
      >
        <span>
          Erhalte Dein Set in <span sx={{ whiteSpace: "nowrap" }}>2-5</span>{" "}
          Werktagen
        </span>
        <StaticImage
          src="./images/products_2x.png"
          alt=""
          height={52}
          sx={{ flexShrink: 0 }}
        />
      </div>
    </Card>
  </>
)

export default Steps
